module.exports = __webpack_public_path__ + "static/media/coverImg-Assurant-Case-Study.45b470c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Assurant/coverImg-Assurant-Case-Study.png
// module id = 127
// module chunks = 0